import { useState, useCallback } from 'react';
import { Node, Edge } from 'reactflow';

interface HistoryItem {
  nodes: Node[];
  edges: Edge[];
}

export const useUndoRedo = () => {
  const [past, setPast] = useState<HistoryItem[]>([]);
  const [future, setFuture] = useState<HistoryItem[]>([]);

  const takeSnapshot = useCallback((nodes: Node[], edges: Edge[]) => {
    // Deep copy to prevent reference issues
    const nodesCopy = JSON.parse(JSON.stringify(nodes));
    const edgesCopy = JSON.parse(JSON.stringify(edges));
    setPast((old) => [...old, { nodes: nodesCopy, edges: edgesCopy }]);
    setFuture([]);
  }, []);

  const undo = useCallback((currentNodes: Node[], currentEdges: Edge[], setNodes: (ns: any) => void, setEdges: (es: any) => void) => {
    if (past.length === 0) return;
    
    const newPast = [...past];
    const previous = newPast.pop(); 
    
    if (previous) {
      setFuture((old) => [{ nodes: currentNodes, edges: currentEdges }, ...old]);
      setPast(newPast);
      setNodes(previous.nodes);
      setEdges(previous.edges);
    }
  }, [past]);

  const redo = useCallback((currentNodes: Node[], currentEdges: Edge[], setNodes: (ns: any) => void, setEdges: (es: any) => void) => {
    if (future.length === 0) return;

    const newFuture = [...future];
    const next = newFuture.shift();

    if (next) {
      setPast((old) => [...old, { nodes: currentNodes, edges: currentEdges }]);
      setFuture(newFuture);
      setNodes(next.nodes);
      setEdges(next.edges);
    }
  }, [future]);

  return { takeSnapshot, undo, redo, canUndo: past.length > 0, canRedo: future.length > 0 };
};